var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div><ng-quill-editor id=\"editor\" ng-model=\"vm.docSvc.doc.notes\" bounds=\"self\"></ng-quill-editor></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/menuitems/tabs/tab-notes.jade
// module id = 204
// module chunks = 0